// extracted by mini-css-extract-plugin
var _1 = "TSmUu";
var _2 = "ba_E6";
var _3 = "vcZXM";
var _4 = "WBiW5";
export { _1 as "cell", _2 as "cellNodeName", _3 as "groupName", _4 as "table" }
